class WordPressAPI {
    constructor(apiURL) {
        this.apiURL = apiURL;
    }

    async makeRequest(routeName, requestData) {
        const fullURL = this.apiURL + routeName;

        try {
            const response = await fetch(fullURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('API-Fehler:', error);
            return error;
        }
    }
}

// Beispielaufruf der Klasse
const wordPressAPI = new WordPressAPI('/wp-json/v1/brautbluete/');

export default wordPressAPI;